module.exports = __webpack_public_path__ + "static/z16-visual-tablet-5b7f41b5b6b5639529a5fb904632734e.jpg";